import React, { useContext } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { VscFilePdf } from "react-icons/vsc";
import Bread from "../../common/Bread";
import Loader from "../../common/Loader";
import { LangContext } from "../../context/LangContext";

const YearInterestRates = () => {
  const lang = useContext(LangContext);
  const nep = lang.state.np; // true if Nepali is active

  const breadcrumList = {
    image: "",
    link: "",
    title: nep ? "आर्थिक वर्ष अनुसार ब्याज दर" : "Interest Rates (Fiscal Year)",
    l1: nep ? "होम" : "Home",
    l2: nep ? "ब्याज दर" : "Interest Rates",
    l3: "",
  };

  const { isLoading, isFetching, error, data } = useQuery({
    queryKey: ["fiscalInterestData"],
    queryFn: () =>
      axios
        .get(`${process.env.REACT_APP_BASE_URL}/fiscal_year_wise_interest`)
        .then((res) => res.data),
  });

  if (isFetching || isLoading) return <Loader />;
  if (error) return "An error has occurred: " + error.message;

  // Pick language-specific titles
  const items = nep ? data?.items : data?.items;

  return (
    <Bread data={breadcrumList}>
      <div className="downloadsPageMainContainer">
        <Tabs className="downloadsPageTabContainer" defaultIndex={0}>
          <TabList className="downloadsPageTabsButtonContainer">
            {items?.map((value, index) => (
              <Tab key={index} className="downloadsPageTabButton">
                {value.title}
              </Tab>
            ))}
          </TabList>

          {items?.map((item, index) => (
            <TabPanel key={index}>
              <div className="downloadsPageResultContainer">
                {item.interest_rates.length > 0 ? (
                  item.interest_rates.map((download, index) => (
                    <a
                      key={index}
                      href={download.DocPath}
                      className="downloadsPageResultItem"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <p className="downloadsPageResultText">
                        {nep ? download.TitleNepali : download.Title}
                      </p>
                      <VscFilePdf
                        className="icon"
                        color="#3a3a3a"
                        size="25px"
                      />
                    </a>
                  ))
                ) : (
                  <h2>{nep ? "डेटा उपलब्ध छैन" : "No data"}</h2>
                )}
              </div>
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </Bread>
  );
};

export default YearInterestRates;
